import React from 'react';

const SmallPostDummy = (props) => (
    <div className={`col-6 col-lg-${props.columnSize}`}>
        <div className="post post--dummy d-flex flex-row justify-content-center">
            <div className="smallpost">
                <span className="smallpost_image"></span>
                <span className="smallpost_byline"></span>
                <span className="smallpost_byline"></span>
            </div>
        </div>
    </div>
);

export default SmallPostDummy;